import actionButtonsPartial from './action_buttons'
import { appendInternalTrackingSearchParams } from '../../utilities/analytics'
import i18n from '../../../../utilities/translation'
const language = document.documentElement.lang

const feedItemTemplate = ({
  link,
  title,
  publisherLogo,
  publisherDarkLogo,
  publisherName,
  isVideoLink,
  thumbnailUrl,
  duration,
  contentType,
  contentTypeText,
  pub_time,
  uid
}) =>
  `
  <article 
    class="block-item" 
    data-mp-content-type="feed_item_link" 
    data-mp-share-link="${appendInternalTrackingSearchParams(link)}" 
    data-mp-share-title="${title}"
    data-mp-share-image="${thumbnailUrl}"
    data-mp-pub-time="${pub_time}"
    data-mp-uid="${uid ? uid : ''}"
    data-gtm-event-type="click"
    data-gtm-share-link="${appendInternalTrackingSearchParams(link)}"
    data-gtm-title="${title}"
  >
    <a class="block-item__body" href="${appendInternalTrackingSearchParams(link)}" data-mp-cct>
      ${
        thumbnailUrl
          ? `
        <div class="block-item__media ${isVideoLink ? 'block-item__media--video' : ''}">
          <img loading="lazy" class="block-item__thumbnail" src="${thumbnailUrl}" />
          ${
            duration
              ? `
              <small class="block-item__media-duration">
                ${duration}
              </small>
            `
              : ''
          }
        </div>
        `
          : ''
      }

      <div class="block-item__body-header">
        <div class="block-item__body-header-light">
          ${
            publisherLogo && publisherName
              ? `<img loading="lazy" class="block-item__publisher-logo" src="${publisherLogo}" alt="${publisherName} logo" />`
              : `
                <small class="block-item__publisher-name">
                  ${publisherName}
                </small>
                `
          }
        </div>

        <div class="block-item__body-header-dark">
          ${
            publisherDarkLogo && publisherName
              ? `<img loading="lazy" class="block-item__publisher-logo" src="${publisherDarkLogo}" alt="${publisherName} logo" />`
              : `
                <small class="block-item__publisher-name">
                  ${publisherName}
                </small>
                `
          }
        </div>
      </div>

      ${title ? `<h1 class="block-item__title">${title}</h1>` : ''}
    </a>

       <footer class="block-item__footer">
      ${
        contentTypeText || contentType
          ? `<small class="block-item__content-type">
              ${contentType ? `<span class="icon icon--media-${contentType}"></span>` : ''}
              ${contentTypeText ? `<span>${i18n(contentTypeText, language)}</span>` : ''}
            </small>`
          : ''
      }
      ${actionButtonsPartial('dark')}
    </footer>
      


  </article>
  `

export default feedItemTemplate
